import {DomainStore} from 'shared/store';
import Presigner from 'shared/stores/documents/Presigner';
import AttachedDocument from 'shared/stores/documents/AttachedDocument';
import {api} from 'shared/core';

/*
  The purpose of this store is uploading files to S3, agnostically of
  where those files are actually used.

  Usually, after using this store to upload a file to S3,
  you associate said file with your model in your own store and save the model.

  For an example, see secure upload.
*/

const PRESIGNER_TYPE = 'presignedPosts';
const PRESIGNER_ENDPOINT = {
  with(modelType) {
    return `secure_upload/presigner?modelType=${modelType}`;
  }
};

function parseXMLKey(xmlFile) {
  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlFile.data, 'text/xml');
  return xml.getElementsByTagName('Key')[0].childNodes[0].nodeValue;
}

class AwsFileStore extends DomainStore {
  async uploadFile(file, modelType) {
    const presigner = await this.fetchPresigner(modelType);

    const {url, data, headers} = presigner.getAwsRequestParams(file);
    const aws = await api.post(url, data, { headers });
    const key = parseXMLKey(aws);
    const contentType = file.type || 'application/octet-stream';

    return new AttachedDocument({
      key,
      fileName: file.name,
      fileSize: file.size,
      contentType: contentType,
      label: file.label,
      previewUrl: file.preview
    });
  }

  async fetchPresigner(modelType = 'secure_upload/secure_file') {
    const presigner = await this.fetch(
      PRESIGNER_ENDPOINT.with(modelType),
      PRESIGNER_TYPE
    );
    return new Presigner(presigner);
  }
}

export default AwsFileStore;
